import React, { useEffect, useState } from "react";
import es_ES from "rsuite/locales/es_ES";
import {
  CButton,
  CCollapse,
  CContainer,
  CForm,
  CNavbar,
  CNavbarBrand,
  CNavbarNav,
  CNavbarToggler,
  CNavItem,
} from "@coreui/react";
import { Citas } from "./Citas";
import { Consulta } from "./Consulta";
import { Pacientes } from "./Pacientes";
import { Servicios } from "./Servicios";
import { ErrorSesion } from "../component/ErrorSesion";
import {
  Container,
  Content,
  Header,
  Breadcrumb,
  Input,
  Button,
  Text,
  List,
  Dropdown,
  HStack,
  SelectPicker,
  Divider,
  toaster,
  Message,
  Modal,
  DatePicker,
  CustomProvider,
  NumberInput,
} from "rsuite";
import { FaTrash, FaSync, FaCheck, FaCashRegister } from "react-icons/fa";
import axios from "../axiosIn";
import { Image, NavItem } from "react-bootstrap";
import ExitIcon from "@rsuite/icons/Exit";
import SiteSettingIcon from "@rsuite/icons/SiteSetting";
import PeopleFolderIcon from "@rsuite/icons/PeopleFolder";
import CalendarIcon from "@rsuite/icons/Calendar";
import { Horarios } from "./Horarios";
import moment from "moment/moment";
import { ClockIcon } from "lucide-react";

export const Inicio = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [consultorio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio.NomConsultorio
  );
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [visible, setVisible] = useState(false);
  const [menuSelected, setMenuSelected] = useState("");
  const [modalSesion, setModalSesion] = useState(false);
  const [nombrePaciente, setNomPaciente] = useState("");
  const sesionIni = JSON.parse(localStorage.getItem("auth")).sesionIni;
  const [listAgendadas, setListAgendadas] = useState([]);
  const [listCobros, setListCobros] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [fecha] = useState(JSON.parse(localStorage.getItem("auth")).fecha);
  const [fechaHorario, setFechaHorario] = useState("");
  const [horario, setHorario] = useState("");
  const [dataHorarios, setDataHorarios] = useState([]);
  const [disableHors, setDisableHors] = useState(true);
  const [listaOpc, setListaOpc] = useState([
    { label: "Citas Agendadas", value: "Agendada" },
    { label: "Citas realizadas", value: "Realizada" },
    { label: "Citas Canceladas", value: "Cancelada" },
  ]);
  const [defaultVal] = useState("Agendada");
  const [opcionSelecc, setOpcSelecc] = useState("Agendada");
  const [fechaCita, setFechaCita] = useState("");
  const [motivoCancel, setMotivoCancel] = useState("");
  const [dataCancel, setDataCancel] = useState("");
  const [espacio, setEspacio] = useState(0);
  const [dataEdit, setDataEdit] = useState("");
  const [disableBtn, setDisableBtn] = useState(true);
  const [btnCancel, setBtnCancel] = useState(false);
  const [telefono, setTelefono] = useState("");
  const [idPaciente, setIdPaciente] = useState(0);
  const [paciente, setPaciente] = useState("");
  const [listFormaPago] = useState([
    { label: "Efectivo", value: "Efectivo" },
    { label: "Tarjeta de Débito", value: "TDD" },
    { label: "Tarjeta de crédito", value: "TDC" },
    { label: "Transferencia", value: "Transferencia" },
  ]);
  const [formaPagoSelec, setFormaPagoSelec] = useState(null);
  const [pago, setPago] = useState(0);

  const menuCliked = (menu) => {
    setMenuSelected(menu);
    setNomPaciente("");
    setVisible(!visible);
  };

  const [total, setTotal] = useState("$ 0.00");
  const [efectivo, setEfectivo] = useState("$ 0.00");
  const [banco, setBanco] = useState("$ 0.00");

  const [open, setOpen] = useState(false);
  const [openHor, setOpenHor] = useState(false);
  const handleClose = () => setOpen(false);
  const handleCloseHorario = () => setOpenHor(false);

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  //                                                      BLOQUE PARA VALIDACIÓN DE SESIÓN                                           //
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  const getCookie = (name) => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
  };

  const validSession = () => {
    var sessionID = getCookie("sessionID");
    var expira = getCookie("expira");
    var dateIsAfter = moment(new Date()).isAfter(moment(expira));

    if (sessionID.length === 0) {
      window.location = `/#/App`;
      window.location.reload();
    }

    if (expira.length > 0) {
      if (dateIsAfter) {
        window.location = `/#/App`;
        window.location.reload();
      }
    }
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  }; 

  
  /// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ///

  const getCitas = async (estatus) => {
    if (estatus === undefined) {
      estatus = "Agendada";
    }

    const id = JSON.parse(localStorage.getItem("auth")).id;

    var url = `Consultas/getCitas/${id}/1/${estatus}`;

    await axios
      .get(url)
      .then((res) => {
        if (estatus === "Agendada" || estatus === "Cancelada") {
          setListAgendadas(res.data.lstCitas);
        } else {
          setTotal(res.data.total);
          setEfectivo(res.data.efec);
          setBanco(res.data.banco);
          setListCobros(res.data.consulta);
        }
      })
      .catch((err) => console.error(err));
  };

  const handleClick = () => {
    setListaOpc([
      { label: "Citas Agendadas", value: "Agendada" },
      { label: "Citas Realizadas", value: "Realizada" },
      { label: "Citas Canceladas", value: "Cancelada" },
    ]);
    if (opcionSelecc === "Agendada") {
      window.location.reload();
    }
    getCitas(opcionSelecc);
  };

  const getPaciente = (props) => {
    const getCita = {
      idConsulta: props.idConsulta,
      espacio: props.espacio,
      idPac: props.idPac,
      nombre: props.nombre,
      fecha: props.fecha,
      hora: props.hora,
      precio: props.precio,
      telefono: props.telefono,
    };

    if (opcionSelecc === "Agendada") {
      setEspacio(props.espacio);
      localStorage.setItem("getCita", JSON.stringify(getCita));
      setMenuSelected("Consulta");
      setNomPaciente(` (${props.hora}) / (${props.espacio}) ${props.nombre}`);
    }
    if (opcionSelecc === "Realizada") {
      localStorage.setItem("getCita", JSON.stringify(getCita));
      setNomPaciente(` / ${props.nombre}`);
    }
    if (opcionSelecc === "Cancelada") {
      setBtnCancel(true);
      setDataCancel(`${props.nombre} / ${props.fecha} ${props.hora}`);
      setOpen(true);
    }
  };

  const getHorarios = async (fecha) => {
    const abortController = new AbortController();
    var url = `Consultas/getHorarios/${idNegocio}/${fecha}`;
    setFechaHorario(fecha);
    try {
      const response = await axios.get(url, { signal: abortController.signal });
      setDataHorarios(response.data);
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        console.log("Err_carga");
      }
    }
  };

  const handleChangeFec = (e) => {
    if (e != null) {
      var fecha = new Date(e).toISOString();
      setDisableHors(false);
      getHorarios(fecha);
    } else {
      setDataHorarios([]);
    }
  };

  const cancelarCita = async () => {
    var url = `Consultas/cancelarCita`;
    const datos = {
      id: idNegocio,
      espacio: espacio,
      fecha: fechaCita,
      idUser: idUser,
      motivo: motivoCancel,
    };

    if (!motivoCancel) {
      toast("Debes escribir un motivo antes de guardar", "warning");
      return;
    }

    await axios
      .post(url, datos)
      .then((res) => {
        if (res === -1) {
          toast(
            "No es posible cancelar la cita, esta se encuentra realizada.",
            "warning"
          );
        }
        if (res.data === 0) {
          toast("No se ha cancelado la cita, intente nuevamente.", "warning");
          return;
        } else {
          toast("La cita se ha cancelado de forma correcta.", "success");
          setOpen(false);
          getCitas("Agendada");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleTipoOpc = (e) => {
    if (e !== null) {
      getCitas(e);
      setOpcSelecc(e);
    } else {
      setOpcSelecc("");
    }
  };

  const handleCancel = (props) => {
    setFechaCita(`${props.fecha} ${props.hora}`);
    setEspacio(props.espacio);
    setDataCancel(
      `${props.nombre} / (${props.espacio}) ${props.fecha} ${props.hora}`
    );
    setOpen(true);
  };

  const handleEditModal = (props) => {
    setIdPaciente(props.idPac);
    setEspacio(props.espacio);
    setFechaCita(`${props.fecha} ${props.hora}`);
    setDataEdit(
      `${props.nombre} / (${props.espacio}) ${props.fecha} ${props.hora}`
    );
    setTelefono(props.telefono);
    setPaciente(props.nombre);
    setOpenHor(true);
  };

  const save = async () => {
    var url = `Consultas/updateCita`;

    const dataCita = {
      id: idNegocio,
      espacio: espacio,
      idPaciente: idPaciente,
      fechaAnterior: fechaCita,
      fecha: fechaHorario.substring(0, 10),
      hora: horario,
      nombre: paciente,
      telefono: telefono,
      correo: "",
      domicilio: "",
      edoMun: "",
      descripCita: "",
    };

    await axios
      .post(url, dataCita, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        if (res.data === -1) {
          toast("El horario ya no se encuentra disponible.", "warning");
          return;
        }
        toast("Se actualizo la cita de forma correcta", "success");
        getCitas("Agendada");
        setDisableBtn(true);
        setOpenHor(false);
      })
      .catch((error) => {
        toast(
          "La fecha y hora de la cita, ya ha sido apartada, intente con otros datos.",
          "warning"
        );
        console.log(error);
      });
  };

  const setCobro = async (props) => {
    if (!formaPagoSelec) {
      toast("Selecciona una forma de pago", "warning");
      return;
    }
    if (!pago || pago === 0) {
      toast("Ingrese un monto.", "warning");
      return;
    }

    var url = `Consultas/guardarCobro`;
    const datos = {
      id: idNegocio,
      idConsulta: props.idConsulta,
      formaPago: formaPagoSelec,
      cobro: pago,
    };

    await axios
      .post(url, datos)
      .then((res) => {
        if (res === 0) {
          toast("No es posible guardar el cobro.", "warning");
        }
        if (res.data > 0) {
          toast("Se ha registrado el pago de forma correcta.", "success");
          setPago(0);
          setFormaPagoSelec(null);
          getCitas("Realizada");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const handleHorario = (e) => {
    if (e === null) {
      setHorario("");
      setDisableBtn(true);
    } else {
      setHorario(e);
      setDisableBtn(false);
    }
  };

  const handleDisabledDate = (date) => {
    return date.getTime() < moment().startOf("day").valueOf();
  };

  useEffect(() => {
    validSession();
    getCitas();

    if (sesionIni === undefined) {
      setModalSesion(true);
    }
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sesionIni]);

  return (
    <>
      <CNavbar expand="lg" className="bg-body-tertiary">
        <CContainer fluid>
          <CNavbarBrand href="#/App/Inicio">{consultorio}</CNavbarBrand>
          <CNavbarToggler onClick={() => setVisible(!visible)} />
          <CCollapse className="navbar-collapse" visible={visible}>
            <CNavbarNav className="me-auto">
              <CNavItem style={{ verticalAlign: "center" }}>
                <CalendarIcon />
                <CButton
                  color="link"
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={() => menuCliked("Citas")}
                >
                  Citas
                </CButton>
              </CNavItem>
              <CNavItem>
                <PeopleFolderIcon />
                <CButton
                  color="link"
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={() => menuCliked("Pacientes")}
                >
                  Pacientes
                </CButton>
              </CNavItem>
              <NavItem>
                <SiteSettingIcon />
                <Dropdown title="Configuraciones">
                  <Dropdown.Item onClick={() => menuCliked("Horarios")}>
                    Horarios
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => menuCliked("Servicios")}>
                    Servicios
                  </Dropdown.Item>
                  {/* <Dropdown.Item>Tipo Documentos</Dropdown.Item> */}
                </Dropdown>
              </NavItem>

            </CNavbarNav>
            {/* <CForm className="d-flex">
              <Input
                type="search"
                className="me-2"
                placeholder="Buscar cita..."
              />
              <Button type="submit" appearance="primary">
                Buscar
              </Button>
            </CForm> */}
          </CCollapse>
        </CContainer>
      </CNavbar>
      <Modal
        open={open}
        onClose={handleClose}
        backdrop="static"
        overflow="false"
      >
        <Modal.Header>
          <Modal.Title>Cita: {dataCancel}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col">
              <b>Motivo</b>
              <Input
                as="textarea"
                rows={4}
                placeholder="Escriba el motivo de la cancelación de la cita."
                onChange={(e) => setMotivoCancel(e)}
                disabled={btnCancel}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={cancelarCita}
            disabled={btnCancel}
            appearance="primary"
          >
            Guardar
          </Button>
          <Button onClick={handleClose} appearance="subtle">
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DE EDICION PARA HORARIO <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
      <Modal
        open={openHor}
        onClose={handleCloseHorario}
        backdrop="static"
        overflow="false"
      >
        <Modal.Header>
          <Modal.Title>Cita: {dataEdit}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-1">
            <div className="col-lg-3 col-md-3 col-sm-3">
              <b>Teléfono</b>
              <Input readOnly value={telefono} />
            </div>
            <div className="col-lg-9 col-md-9 col-sm-9">
              <b>Nombre</b>
              <Input readOnly value={paciente} />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-lg-6 col-md-6 col-sm-6">
              <b>Fecha</b>
              <CustomProvider locale={es_ES}>
                <DatePicker
                  block
                  shouldDisableDate={handleDisabledDate}
                  onChange={(e) => handleChangeFec(e)}
                />
              </CustomProvider>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <b>Horarios</b>
              <SelectPicker
                style={{ width: "auto" }}
                block
                searchable={false}
                data={dataHorarios}
                disabled={disableHors}
                onChange={(e) => handleHorario(e)}
                placeholder="Selecciona un horario"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button appearance="ghost" onClick={save} disabled={disableBtn}>
            Guardar
          </Button>
          <Button onClick={handleCloseHorario} appearance="ghost">
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {!modalSesion ? (
        <Container
          style={{
            padding: 20,
            marginRight: "auto",
            marginLeft: "auto",
            // backgroundImage: `url(Images/5968949.jpg?v=${new Date().getTime()})`,
            backgroundColor: "#F7F5F5",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "absolute",
            height: "100%",
            width: "100%",
            overflow: "auto",
          }}
        >
          <Header>
            {menuSelected === "" ? (
              ""
            ) : (
              <Breadcrumb style={{ fontSize: "18px", textDecoration: "none" }}>
                <Breadcrumb.Item
                  style={{ textDecoration: "none" }}
                  href="#/App/Inicio"
                  onClick={() => setMenuSelected("")}
                >
                  Inicio
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                  {menuSelected} {nombrePaciente}
                </Breadcrumb.Item>
              </Breadcrumb>
            )}
          </Header>
          <Content style={{ width: "100%" }}>
            {menuSelected === "" ? (
              <div
                style={{
                  marginLeft: "5%",
                  marginRight: "5%",
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "15px",
                }}
              >
                <div className="row">
                  <HStack
                    spacing={5}
                    divider={<Divider vertical />}
                    style={{ height: 40 }}
                  >
                    <Text color="blue" weight="bold">
                      Citas de hoy ({listAgendadas.length})
                    </Text>
                    <SelectPicker
                      searchable={false}
                      data={listaOpc}
                      size="lg"
                      defaultValue={`${defaultVal}`}
                      style={{ width: "15%" }}
                      block
                      placeholder="Filtrar por"
                      onChange={(e) => handleTipoOpc(e)}
                    ></SelectPicker>
                    <Button
                      appearance="subtle"
                      startIcon={<FaSync />}
                      onClick={() => handleClick()}
                      title="Actualizar"
                    ></Button>
                  </HStack>
                  <div className="col-lg-7 col-md-7 col-sm-7">
                    {opcionSelecc === "Agendada" ? (
                      <br></br>
                    ) : opcionSelecc === "Realizada" ? (
                      <>
                        <br></br>
                        <HStack
                          spacing={70}
                          divider={<Divider vertical />}
                          style={{ height: 40 }}
                        >
                          <div style={{ alignContent: "end" }}>
                            <b>Total pagos: {total}</b>
                          </div>
                          <div>
                            <b>Total efectivo: {efectivo}</b>
                          </div>
                          <div>
                            <b>Total banco: {banco}</b>
                          </div>
                        </HStack>
                        <br></br>
                      </>
                    ) : (
                      <br></br>
                    )}
                    {opcionSelecc === "Agendada" ? (
                      <List style={{ flex: 1 }} bordered key={"list-agendada"}>
                        {listAgendadas.map((item) => (
                          <List.Item key={item.hora} index={item.dia}>
                            <div style={{ fontSize: "15px" }}>
                              ({item.espacio}) Horario: {item.hora} &nbsp;{" "}
                              <Button
                                appearance="subtle"
                                title="Cancelar cita"
                                onClick={() =>
                                  handleCancel({
                                    nombre: item.nombre,
                                    espacio: item.espacio,
                                    fecha: item.fecha,
                                    hora: item.hora,
                                    telefono: item.telefono,
                                  })
                                }
                              >
                                <FaTrash
                                  style={{ color: "red", fontSize: "15px" }}
                                ></FaTrash>
                              </Button>
                              <Button
                                onClick={() =>
                                  handleEditModal({
                                    idPac: item.idPac,
                                    nombre: item.nombre,
                                    espacio: item.espacio,
                                    fecha: item.fecha,
                                    hora: item.hora,
                                    telefono: item.telefono,
                                  })
                                }
                                appearance="subtle"
                                title="Editar horario"
                              >
                                <ClockIcon
                                  size="15px"
                                  style={{ color: "blue" }}
                                ></ClockIcon>
                              </Button>
                            </div>
                            <div>
                              <Button
                                size="sm"
                                key={item.dia}
                                appearance="subtle"
                                style={{ color: "#1d85fb" }}
                                onClick={() =>
                                  getPaciente({
                                    idConsulta: item.idConsulta,
                                    espacio: item.espacio,
                                    idPac: item.idPac,
                                    fecha: item.fecha,
                                    hora: item.hora,
                                    telefono: item.telefono,
                                    precio: item.precio,
                                    nombre: item.nombre,
                                  })
                                }
                              >
                                {item.nombre}
                              </Button>
                            </div>
                            <div className="row">
                              <div className="col-lg-4 col-md-4 col-sm-4">
                                {item.estatus === "Realizada" ? (
                                  <NumberInput
                                    controls={false}
                                    key={`Monto-${item.idConsulta}`}
                                    placeholder={`Importe a pagar: ${item.precio}`}
                                    min={0}
                                    style={{ textAlign: "center" }}
                                    onChange={(e) => setPago(e)}
                                  />
                                ) : item.estatus === "Pagada" ? (
                                  `Cobrado: ${item.cobro}`
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                {item.estatus === "Realizada" ? (
                                  <Button
                                    startIcon={
                                      <FaCashRegister></FaCashRegister>
                                    }
                                    key={`Button-${item.idConsulta}`}
                                    appearance="ghost"
                                    block
                                    onClick={() =>
                                      setCobro({
                                        idConsulta: item.idConsulta,
                                        idPac: item.idPac,
                                      })
                                    }
                                  >
                                    Cobrar
                                  </Button>
                                ) : item.estatus === "Pagada" ? (
                                  ""
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </List.Item>
                        ))}
                      </List>
                    ) : (
                      <List style={{ flex: 1 }} bordered key={"list-Cobros"}>
                        {listCobros.map((item) => (
                          <List.Item key={item.hora} index={item.dia}>
                            <div style={{ fontSize: "15px" }}>
                              ({item.espacio}) Horario: {item.hora} &nbsp;{" "}
                            </div>
                            <div>
                              <Button
                                size="sm"
                                key={item.dia}
                                appearance="subtle"
                                style={{ color: "#1d85fb" }}
                                onClick={() =>
                                  getPaciente({
                                    idConsulta: item.idConsulta,
                                    espacio: item.espacio,
                                    idPac: item.idPac,
                                    fecha: item.fecha,
                                    hora: item.hora,
                                    telefono: item.telefono,
                                    precio: item.precio,
                                    nombre: item.nombre,
                                  })
                                }
                              >
                                {item.nombre}
                              </Button>
                            </div>
                            <div className="row">
                              <div className="col-lg-5 col-md-5 col-sm-5">
                                {item.estatus === "Realizada" ? (
                                  <SelectPicker
                                    key={`Picker-${item.idConsulta}`}
                                    searchable={false}
                                    placeholder="Forma de pago"
                                    style={{ width: "90%" }}
                                    onChange={(e) => setFormaPagoSelec(e)}
                                    data={listFormaPago}
                                  ></SelectPicker>
                                ) : item.estatus === "Pagada" ? (
                                  `${" "}Forma de pago: ${item.formaPago}`
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="col-lg-4 col-md-4 col-sm-4">
                                {item.estatus === "Realizada" ? (
                                  <NumberInput
                                    controls={false}
                                    key={`Monto-${item.idConsulta}`}
                                    placeholder={`Importe a pagar: ${item.precio}`}
                                    min={0}
                                    style={{ textAlign: "center" }}
                                    onChange={(e) => setPago(e)}
                                  />
                                ) : item.estatus === "Pagada" ? (
                                  `Cobrado: ${item.cobro}`
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                {item.estatus === "Realizada" ? (
                                  <Button
                                    startIcon={
                                      <FaCashRegister></FaCashRegister>
                                    }
                                    key={`Button-${item.idConsulta}`}
                                    appearance="ghost"
                                    block
                                    onClick={() =>
                                      setCobro({
                                        idConsulta: item.idConsulta,
                                        idPac: item.idPac,
                                      })
                                    }
                                  >
                                    Cobrar
                                  </Button>
                                ) : item.estatus === "Pagada" ? (
                                  ""
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </List.Item>
                        ))}
                      </List>
                    )}
                  </div>
                  &nbsp;
                  <div className="text-center col-lg-2 col-md-2 col-sm-2">
                    {!isMobile ? (
                      <Image
                        src={`/Images/Negocios/${idNegocio}.png`}
                        style={{ width: "300x", borderRadius: "10px" }}
                      />
                    ) : (
                      <Image
                        src={`/Images/Negocios/${idNegocio}.png`}
                        style={{ width: "180px", borderRadius: "10px" }}
                      />
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {menuSelected === "Citas" ? <Citas /> : ""}
            {menuSelected === "Consulta" ? (
              <Consulta noEspacio={espacio} />
            ) : (
              ""
            )}
            {menuSelected === "Horarios" ? <Horarios /> : ""}
            {menuSelected === "Pacientes" ? <Pacientes /> : ""}
            {menuSelected === "Servicios" ? <Servicios /> : ""}
          </Content>
        </Container>
      ) : (
        <ErrorSesion />
      )}
    </>
  );
};
